
export default function WhyAnnalogix() {
  const reasons = [
    'Designed for complex, service-driven operations',
    'AI applied as infrastructure, not hype',
    'Compliance- and accuracy-aware systems',
    'Clear, measurable operational outcomes',
    'Advisory partnership from strategy through implementation'
  ];

  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Why Teams Trust Annalogix
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            Trusted by organizations that value clarity, precision, and long-term operational stability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="flex items-start p-6 bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mr-4 mt-0.5">
                <i className="ri-check-line text-xl text-blue-400"></i>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed">
                {reason}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
